import React, {
  useCallback,
  useEffect,
  useReducer,
  useRef,
  useState,
} from 'react';
import '../../LeaseTransactionJourney.scss';
import xCloseIcon from '../../../../../assets/images/icons/x-close-dialog.svg';
import { DialogActions, DialogContent, ButtonBase } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { showWarn, GlobalHistory, showError } from '../../../../../Helper';
import { UnitsStatusEnum } from '../../../../../Enums';
import {
  AutocompleteComponent,
  DialogComponent,
} from '../../../../../Components';
import {
  PageHeading,
  AboutUnitCard,
  MessageConfirmDialog,
} from '../../../../../SharedComponents';
import {
  UnitsAdvanceSearchTest,
  CanSetUnitAsReservedOrLeasedOrSale,
  GetOpenTenantLeads,
} from '../../../../../Services';
import { UnitMapper } from '../../../UnitsSalesView/UnitMapper/UnitMapper.jsx';
import { TransactionStepsData } from '../TransactionStepsData.jsx';
import MissingInformationErrorMSG from './MissingInformationErrorMSG.jsx';
import { ApplicationUserSearch } from '../../../../../Services/userServices.jsx';
import { AgentRoleEnum } from '../../../../../Enums/AgentRoleEnum';
import { useKeyGenerator } from '../../../../../Hooks/keyGenerator.jsx';

export const TransactionUnitSelectionDialog = ({
  isDialogOpen,
  onClose,
  activeUnitId,
}) => {
  const parentTranslationPath = 'LeaseTransactionJourney';
  const translationPath = 'UnitSelection.';

  const { t } = useTranslation(parentTranslationPath);
  const searchTimer = useRef(null);
  const [key, refresh] = useKeyGenerator();
  const reducer = useCallback((state, action) => {
    if (action.id !== 'edit') return { ...state, [action.id]: action.value };
    return {
      ...action.value,
    };
  }, []);

  const [selected, setSelected] = useReducer(reducer, {
    unitId: null,
    RefNoUnit: null,
    UnitNumberUnit: null,
    leasingAgent: null,
    lead: null,
  });
  const [data, setData] = useReducer(reducer, {
    RefNoUnits: [],
    UnitNumberUnits: [],
    initUnit: null,
    leasingAgent: [],
    lead: [],
  });
  const [isLoading, setIsLoading] = useState({
    RefNoUnits: false,
    UnitNumberUnits: false,
    initUnit: false,
    leasingAgent: false,
    lead: false,
  });
  const [isMissingInfoMSGOpen, setIsMissingInfoMSGOpen] = useState(false);

  const getUnits = async ({ unitRefNo, unitNumber }) => {
    const stateKey =
      (activeUnitId && 'initUnit') ||
      (unitRefNo && 'RefNoUnits') ||
      (unitNumber && 'UnitNumberUnits');

    setIsLoading((prevState) => ({ ...prevState, [stateKey]: true }));

    const criteria = {};

    if (unitRefNo)
      criteria['unit_ref_no'] = [
        {
          searchType: 2,
          value: unitRefNo,
        },
      ];
    if (unitNumber)
      criteria['unit_number'] = [
        {
          searchType: 2,
          value: unitNumber,
        },
      ];
    if (activeUnitId)
      criteria['unitId'] = [
        {
          searchType: 2,
          value: activeUnitId,
        },
      ];

    criteria['status'] = [
      {
        searchType: 1,
        value: 'Available',
      },
    ];

    const body = {
      criteria,
      filterBy: 'createdOn',
      orderBy: 2,
      OperationType: 'Lease',
    };

    const res = await UnitsAdvanceSearchTest(
      { pageIndex: 0, pageSize: 10 },
      body
    );
    if (!(res && res.status && res.status !== 200)) {
      const mappedResult = res.result?.map(
        (item) =>
          item.unitJson && UnitMapper(item, JSON.parse(item.unitJson).unit)
      );
      const units =
        activeUnitId && mappedResult?.length > 0
          ? mappedResult[0]
          : mappedResult;
      setData({ id: stateKey, value: units });
    } else setData({ id: stateKey, value: [] });

    setIsLoading((prevState) => ({ ...prevState, [stateKey]: false }));
  };

  const checkIsTransactionValid = async () => {
    const tenantLeadsData = {
      contact: {
        contactId: selected.lead?.contactId,
        contactName: selected.lead?.leadName,
      },
      lead: {
        leadId: selected.lead?.leadId,
        leadName: selected.lead?.leadName,
      },
      leasingAgent: {
        agentId: selected.lead?.referredToId,
        agentName: selected.lead?.referredToName,
      },
    };
    const newStatus = UnitsStatusEnum.UnderOffer.key;
    const res = await CanSetUnitAsReservedOrLeasedOrSale(
      selected.unitId,
      newStatus
    );
    if (res) {
      const nextStep = TransactionStepsData.TenantSelection;
      GlobalHistory.push(
        `/home/lease-transaction-journey?id=${selected.unitId}&step=${nextStep.key}`,
        {
          tenantLeadsData,
        }
      );
      onClose();
    } else setIsMissingInfoMSGOpen(true);
  };

  const submitHandler = async () => {
    if (!selected.unitId) {
      showWarn(t(`${translationPath}please-select-unit-error`));
      return;
    }

    await checkIsTransactionValid();
  };

  const confirmMissingInfoDialog = () => {
    const activeUnit =
      data.initUnit || selected.UnitNumberUnit || selected.RefNoUnit;
    setIsMissingInfoMSGOpen(false);
    onClose();
    const URLPath = `/home/units-lease/unit-profile-edit?formType=${activeUnit.unitTypeId}&id=${activeUnit.id}`;

    const isUnitLeaseView = !activeUnitId;
    if (isUnitLeaseView) window.open(URLPath, '_blank');
    else window.location.replace(URLPath);
  };

  const cancelMissingInfoDialog = () => {
    setIsMissingInfoMSGOpen(false);
  };

  const getOpenTenantLeads = async (value) => {
    setIsLoading((prev) => ({ ...prev, lead: true }));
    let agentId = '';
    let leadId = '';
    let leadName = '';
    if (+value === 0 || !value) {
      agentId = '';
      leadId = '';
      leadName = '';
    } else if (value && typeof value === 'object') {
      agentId = value.usersId;
    } else if (!isNaN(+value)) {
      leadId = +value;
    } else if (typeof value === 'string') {
      leadName = value;
    }

    const body = {
      pageIndex: 0,
      pageSize: 10,
      agentId,
      leadId,
      leadName,
    };

    try {
      const res = await GetOpenTenantLeads(body);
      setData({ id: 'lead', value: res.result });
      if ((leadId || leadName) && res.result.length === 0) {
        showError(t(`${translationPath}selected-lead-must-be`));
      }
      if (agentId && res.result.length === 0) {
        setSelected({ id: 'leasingAgent', value: null });
        showError(t(`${translationPath}no-matching-leads`));
      }
    } catch {
      showError(t('something-went-wrong'));
    } finally {
      setIsLoading((prev) => ({ ...prev, lead: false }));
    }
  };

  const getLeaseAgent = async (searchValue) => {
    setIsLoading((prev) => ({ ...prev, leasingAgent: true }));
    const body = {
      pageIndex: 0,
      pageSize: 25,
      name: searchValue || '',
      userTypeId: AgentRoleEnum.LeaseAgent.value,
    };
    const res = await ApplicationUserSearch(body);
    if (!(res && res.status && res.status !== 200)) {
      setData({ id: 'leasingAgent', value: res.result });
    } else setData({ id: 'leasingAgent', value: [] });

    setIsLoading((prev) => ({ ...prev, leasingAgent: false }));
  };

  useEffect(() => {
    if (activeUnitId) {
      getUnits({});
      setSelected({ id: 'unitId', value: activeUnitId });
    }
  }, [activeUnitId]);

  useEffect(() => {
    getOpenTenantLeads();
    getLeaseAgent();
  }, []);

  return (
    <div>
      <DialogComponent
        isOpen={isDialogOpen}
        maxWidth='sm'
        dialogTitle={
          <div className='user-groups-view add-task-dialog w-100'>
            <div className='d-flex-v-center-h-between fa-start'>
              <PageHeading
                parentTranslationPath={parentTranslationPath}
                translationPath={translationPath}
                headerTitle={'Start-transaction'}
                subTitle={'Start-transaction-heading'}
                wrapperClasses={'m-0'}
                headerTitleClasses={'m-0 fz-16'}
                subTitleClasses={'m-0 fz-12'}
              />
              <div
                className='xCloseIcon pointer'
                onClick={onClose}
              >
                <img src={xCloseIcon} />
              </div>
            </div>
          </div>
        }
        dialogContent={
          <div className='Transaction-Layout '>
            <DialogContent>
              <>
                <div className='d-flex fj-start mb-3'>
                  <div className='w-33 mt-1'>
                    <span className='fw-simi-bold'>
                      {t(`${translationPath}UnitNumber`)}
                    </span>
                  </div>
                  <div className='w-75'>
                    <AutocompleteComponent
                      idRef='unitNumberRef'
                      wrapperClasses='w-min-unset mt-1'
                      selectedValues={selected.UnitNumberUnit}
                      inputPlaceholder={t(`select`)}
                      multiple={false}
                      data={data.UnitNumberUnits ?? []}
                      displayLabel={(option) =>
                        option?.refNo || option?.unit_ref_no || ''
                      }
                      getOptionSelected={(option, value) =>
                        option.id === value.id
                      }
                      isDisabled={activeUnitId}
                      withoutSearchButton
                      isLoading={isLoading.UnitNumberUnits}
                      onChange={(_, newValue) => {
                        setSelected({
                          id: 'edit',
                          value: {
                            ...selected,
                            unitId: newValue?.id || null,
                            RefNoUnit: null,
                            UnitNumberUnit: newValue,
                          },
                        });
                      }}
                      onInputChange={(_, value) => {
                        if (activeUnitId) {
                          return;
                        }
                        if (searchTimer.current)
                          clearTimeout(searchTimer.current);
                        searchTimer.current = setTimeout(() => {
                          if (value) getUnits({ unitNumber: value });
                        }, 1400);
                      }}
                    />
                  </div>
                </div>

                <div className='OR-seperator d-flex-center'>
                  <span className='line w-100'></span>
                  <span className='fw-simi-bold light-text m-1'>
                    {t(`${translationPath}or`)}
                  </span>
                  <span className='line w-100'></span>
                </div>
                <div className='d-flex fj-start my-3'>
                  <div className='w-33 mt-1'>
                    <span className='fw-simi-bold'>
                      {t(`${translationPath}UnitRefNo`)}
                    </span>
                  </div>
                  <div className='w-75'>
                    <AutocompleteComponent
                      idRef='UnitRefNoRef'
                      wrapperClasses='w-min-unset mt-1'
                      selectedValues={data.initUnit || selected.RefNoUnit}
                      inputPlaceholder={t(`select`)}
                      multiple={false}
                      data={data.RefNoUnits || []}
                      displayLabel={(option) =>
                        option?.refNo || option?.unit_ref_no || ''
                      }
                      getOptionSelected={(option, value) =>
                        option.id === value.id
                      }
                      isDisabled={activeUnitId}
                      withoutSearchButton
                      isLoading={isLoading.RefNoUnits}
                      onChange={(_, newValue) => {
                        setSelected({
                          id: 'edit',
                          value: {
                            ...selected,
                            unitId: newValue?.id || null,
                            RefNoUnit: newValue,
                            UnitNumberUnit: null,
                          },
                        });
                      }}
                      onInputChange={(_, value) => {
                        if (searchTimer.current)
                          clearTimeout(searchTimer.current);
                        searchTimer.current = setTimeout(() => {
                          if (value) getUnits({ unitRefNo: value });
                        }, 1400);
                      }}
                    />
                  </div>
                </div>
                <span className='line w-100'></span>
                <div className='d-flex fj-start my-3'>
                  <div className='w-33 mt-1'>
                    <span className='fw-simi-bold'>
                      {t(`${translationPath}leasingAgent`)}
                    </span>
                  </div>
                  <div className='w-75'>
                    <AutocompleteComponent
                      idRef='LeasingAgentNameRef'
                      wrapperClasses='w-min-unset mt-1'
                      selectedValues={selected.leasingAgent}
                      withLoader
                      inputPlaceholder={t(`select`)}
                      multiple={false}
                      data={data.leasingAgent || []}
                      displayLabel={(option) => option?.fullName || ''}
                      withoutSearchButton
                      isLoading={isLoading.leasingAgent}
                      onChange={(_, newValue) => {
                        setSelected({
                          id: 'edit',
                          value: {
                            ...selected,
                            leasingAgent: newValue,
                            lead: null,
                          },
                        });
                        getOpenTenantLeads(newValue);
                      }}
                      onInputChange={(_, value) => {
                        if (searchTimer.current)
                          clearTimeout(searchTimer.current);
                        searchTimer.current = setTimeout(() => {
                          getLeaseAgent(value);
                        }, 1400);
                      }}
                    />
                  </div>
                </div>
                <div className='d-flex fj-start my-3'>
                  <div className='w-33 mt-1'>
                    <span className='fw-simi-bold'>
                      {t(`${translationPath}lead`)}
                    </span>
                  </div>
                  <div className='w-75'>
                    <AutocompleteComponent
                      key={key}
                      idRef='LeadRef'
                      wrapperClasses='w-min-unset mt-1'
                      selectedValues={selected.lead}
                      withLoader
                      inputPlaceholder={t(`select`)}
                      multiple={false}
                      data={data.lead || []}
                      filterOptions={(options, { inputValue }) =>
                        options.filter((item) =>
                          !!inputValue
                            ? item.leadName
                                .toLowerCase()
                                .includes(inputValue.toLowerCase()) ||
                              item.leadId === +inputValue
                            : true
                        )
                      }
                      displayLabel={(option) => option?.leadName || ''}
                      withoutSearchButton
                      isLoading={isLoading.lead}
                      onChange={(_, newValue) => {
                        if (!newValue) {
                          setSelected({
                            id: 'edit',
                            value: {
                              ...selected,
                              lead: null,
                              leasingAgent: null,
                            },
                          });
                          return;
                        }
                        if (newValue?.referredToName) {
                          setSelected({
                            id: 'edit',
                            value: {
                              ...selected,
                              lead: newValue,
                              leasingAgent: {
                                usersId: newValue.referredToId,
                                fullName: newValue.referredToName,
                              },
                            },
                          });
                        } else {
                          setSelected({ id: 'lead', value: null });
                          refresh();
                          showError(t(`${translationPath}no-matching-agent`));
                        }
                      }}
                      onInputChange={(_, value) => {
                        setSelected({ id: 'leasingAgent', value: null });
                        if (searchTimer.current)
                          clearTimeout(searchTimer.current);
                        searchTimer.current = setTimeout(() => {
                          getOpenTenantLeads(value);
                        }, 1400);
                      }}
                    />
                  </div>
                </div>

                {selected.unitId ? (
                  <>
                    <span className='line w-100'></span>

                    <div className='d-flex fj-start my-3'>
                      <div className='w-33 mt-1'>
                        <span className='fw-simi-bold'>
                          {t(`${translationPath}unit-details`)}
                        </span>
                      </div>
                      <div className='w-75'>
                        <AboutUnitCard
                          unitData={
                            data.initUnit ||
                            selected.RefNoUnit ||
                            selected.UnitNumberUnit
                          }
                          orientation='horizantal'
                        />
                      </div>
                    </div>
                  </>
                ) : null}
              </>
            </DialogContent>
            <DialogActions>
              <div className='d-flex-center fj-end py-0 pt-3'>
                <ButtonBase
                  onClick={onClose}
                  className='btns theme-propx outlined'
                >
                  {t(`cancel`)}
                </ButtonBase>

                <ButtonBase
                  className='btns theme-propx solid mr-0'
                  onClick={submitHandler}
                  disabled={!selected.lead || !selected.leasingAgent}
                >
                  {t(`start`)}
                </ButtonBase>
              </div>
            </DialogActions>
          </div>
        }
      />
      {isMissingInfoMSGOpen && (
        <MessageConfirmDialog
          isDialogOpen={isMissingInfoMSGOpen}
          theme='warning'
          content={{
            heading: 'Missing-Information',
            body: <MissingInformationErrorMSG />,
          }}
          confirmButton={{
            label: 'Update-unit-details',
            handler: confirmMissingInfoDialog,
          }}
          cancelButton={{
            label: 'discard',
            handler: cancelMissingInfoDialog,
          }}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
        />
      )}
    </div>
  );
};
